import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./lms.css";

// Dark dialog behind lmsConfirm / lmsPrompt. onDone(null) = cancelled.
// summary: optional block (e.g. the class name and time) shown in a box under the title.
// input: { placeholder, maxLength } adds a text box, and confirming returns its text.
// Kept apart from LmsUI so the admin header can use it without the LMS page CSS.
const LmsDialog = ({ title, summary, message, confirmLabel = "Confirm", cancelLabel = "Go back", danger = false, input, onDone }) => {
  const [value, setValue] = useState("");
  return (
    <div className="lms-confirm" role="alertdialog" aria-modal="true" aria-labelledby="lms-confirm-title">
      <h2 id="lms-confirm-title" className="lms-confirm-title">{title}</h2>
      {summary && <div className="lms-confirm-summary">{summary}</div>}
      {message && <p className="lms-confirm-text">{message}</p>}
      {input && (
        <textarea
          className="lms-input lms-confirm-input"
          rows={3}
          autoFocus
          maxLength={input.maxLength}
          placeholder={input.placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}
      <div className="lms-confirm-actions">
        <button type="button" className="lms-btn" onClick={() => onDone(null)} autoFocus={!input}>{cancelLabel}</button>
        <button type="button" className={`lms-btn ${danger ? "lms-btn-danger-fill" : "lms-btn-primary"}`} onClick={() => onDone(input ? value.trim() : true)}>
          {confirmLabel}
        </button>
      </div>
    </div>
  );
};

// Shows any dialog on the dark overlay. render(onDone) returns its body; onDone(result) closes it.
// Esc and a click outside also close it. Resolves to the result, or `cancelled` (also for onDone(null)).
export const lmsDialog = (render, cancelled) =>
  new Promise((resolve) => {
    confirmAlert({
      overlayClassName: "lms-confirm-overlay",
      afterClose: () => resolve(cancelled),
      customUI: ({ onClose }) =>
        render((result) => {
          resolve(result ?? cancelled);
          onClose();
        }),
    });
  });

const openDialog = (options, cancelled) => lmsDialog((onDone) => <LmsDialog {...options} onDone={onDone} />, cancelled);

// Yes / no. Resolves true on confirm, false otherwise.
export const lmsConfirm = (options) => openDialog(options, false);

// With a text box. Resolves to the typed text ("" when left empty), or null when cancelled.
export const lmsPrompt = ({ input = {}, ...options }) => openDialog({ ...options, input }, null);
